export enum BeforeSaveMode {
    DontAttachUnsoldVersions,
    DontAttachItems,
    Disabled
}